/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import LPOFormManual from './LPOFormManual';
import LPOFormVoice from './LPOFormVoice';

export default function LPOFormLayout() {
  const location = useLocation();

  // Determine which form to render based on route
  const isVoiceMode = location.pathname.includes('/voice');
  const isManualMode = location.pathname.includes('/manual');

  return (
    <div className="font-display bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100 antialiased">
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar Navigation */}
        <Sidebar />

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto p-8">
          {/* Header */}
          <header className="flex justify-between items-center mb-10">
            <div>
              <h2 className="text-3xl font-black text-slate-900 dark:text-white tracking-tight">
                {isVoiceMode ? 'Secure Voice Capture' : 'Manual Submission'}
              </h2>
              <p className="text-slate-500 mt-1">
                {isVoiceMode
                  ? 'Enterprise-grade encrypted audio and metadata recording'
                  : 'Submit supplier information with photo evidence'}
              </p>
            </div>
            <div className="flex items-center gap-4">
              {/* Encryption Status Badge */}
              <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 rounded-full border border-emerald-200 dark:border-emerald-800/50">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                </span>
                <span className="text-xs font-bold uppercase tracking-tight">AES-256 Enabled</span>
              </div>
              {/* Notifications */}
              <button className="size-10 rounded-full border border-slate-200 dark:border-slate-700 flex items-center justify-center hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                <span className="material-symbols-outlined text-slate-600 dark:text-slate-400">notifications</span>
              </button>
            </div>
          </header>

          {/* Render the appropriate form */}
          {isVoiceMode && <LPOFormVoice />}
          {isManualMode && <LPOFormManual />}
          {!isVoiceMode && !isManualMode && <LPOFormVoice />}
        </main>
      </div>
    </div>
  );
}
